import androidLogo from './images/logos/logoAndroid.svg';
import certificateLogo from './images/logos/certificateLogo.svg';
import dockerLogo from './images/logos/dockerLogo.svg';
import emailLogo from './images/envelope.svg';
import fsLogo from './images/logos/logoFSWhite2.svg';
import fsLogoBW from './images/logos/logoFSBlack.svg';
import githubLogo from './images/github.svg';
import iconMoon from './images/iconMoon.svg';
import iconSun from './images/iconSun.svg';
import javaLogo from './images/logos/javaLogo2.svg';
import javascriptLogo from './images/logos/javascriptLogo2.svg';
import jetpackComposeLogo from './images/logos/jetpackComposeLogo.png';
import kotlinLogo from './images/logos/kotlinLogo.svg';
import mysqlLogo from './images/logos/mysqlLogo.svg';
import linkedIn from './images/logos/linkedIn.svg'
import logoPlaystore from './images/logos/logoPlayStore.svg';
import profilePicture from './images/siffert_profile_small.png';
import reactLogo from './images/logos/reactLogo.svg';
import sassLogo from './images/logos/sassLogoColor.svg';
import logoSatellite from './images/logos/logoSatellite.svg';
import scholar from './images/scholar.svg';
import springLogo from './images/logos/springLogo.svg';
import starFilled from './images/starFilled.svg';
import starOutline from './images/starOutline.svg';
import studyCap from './images/logos/studyLogo.svg';
import swiftLogo from './images/logos/swiftLogo.svg';
import swiftUILogo from './images/logos/swiftUiLogo.svg';
import typescriptLogo from './images/logos/typescriptLogo.svg';

export {
    androidLogo,
    certificateLogo,
    dockerLogo,
    emailLogo,
    fsLogo,
    fsLogoBW,
    githubLogo,
    iconMoon,
    iconSun,
    javaLogo,
    javascriptLogo,
    jetpackComposeLogo,
    kotlinLogo,
    linkedIn,
    logoPlaystore,
    logoSatellite,
    mysqlLogo,
    profilePicture,
    reactLogo,
    sassLogo,
    scholar,
    springLogo,
    starFilled,
    starOutline,
    studyCap,
    swiftLogo,
    swiftUILogo,
    typescriptLogo,
};
